<script>
import useTools from "@/use/Tools";
import {useSecurityStore} from "@/stores/Security";

export default {
    props: {
        items: Array,
        loading: Boolean,
        rootPath: String,
        intranet: Boolean,
        identity: String,
        search: String,
    },
    emits: ["view"],
    setup(props, { emit }) {
        const {$i18n, $router} = useTools();
        const securityStore = useSecurityStore();
        
        const headers = [
            {
                text: "...",
                align: "left",
                sortable: false,
                value: "action",
                width: "0%"
            },
            {
                text: $i18n.t("common.code"),
                align: "left",
                sortable: true,
                value: "code",
                width: "0%"
            },
            {
                text: $i18n.t("common.label"),
                align: "left",
                sortable: true,
                value: "name",
                width: "0%"
            },
            {
                text: $i18n.t("common.concerned"),
                align: "left",
                sortable: false,
                value: "concerned",
                width: "0%"
            },
            {
                text: $i18n.t("common.comment"),
                align: "left",
                sortable: true,
                value: "description",
            },
        ];
        
        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_EVALUATION_PARAM'] && !props.intranet,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${props.rootPath}.edit`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t('common.duplicate'),
                icon: 'mdi-plus-circle-multiple-outline',
                color: 'teal',
                access: () => securityStore.authorities['UPDATE_EVALUATION_PARAM'] && !props.intranet,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${props.rootPath}.duplicate`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_EVALUATION_PARAM'] && !props.intranet,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${props.rootPath}.delete`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.archive"),
                icon: 'mdi-archive',
                color: 'purple',
                access: (item) => securityStore.authorities['UPDATE_EVALUATION_PARAM'] && !item.archive && !props.intranet,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${props.rootPath}.archive`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.unarchive"),
                icon: 'mdi-archive',
                color: 'purple',
                access: (item) => securityStore.authorities['UPDATE_EVALUATION_PARAM'] && item.archive && !props.intranet,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${props.rootPath}.unarchive`, params: {id: item.id}})
                },
            },
        ];
        
        function view(item) {
            emit('view', item);
        }
        
        return {
            headers,
            actions,
            view,
        }
    }
}


</script>

<template>
    <w-data-table
        :identity="identity"
        :headers="headers"
        :actions="actions"
        :items="items"
        :search="search"
        :total="items.length"
        :loading="loading"
        sort-by="name"
        @rowDbClick="view"
    >
        <template v-slot:[`item.code`]="{ item }">
            <w-chip :text="item.code"/>
        </template>
        <template v-slot:[`item.name`]="{ item }">
            <w-inline-text bold :text="item.name"/>
        </template>
        <template v-slot:[`item.concerned`]="{ item }">
            <w-chip-list
                v-if="item.scope === 'OCCUPATION'"
                :strings="item.occupationNames"
            />
            <w-chip-list
                v-if="item.scope === 'WORKER'"
                :strings="item.workerNames"
            />
        </template>
    </w-data-table>
</template>

<style scoped>

</style>